export enum EvolutionStatus {
    InProgress,
    Finalized
}